"use client";

import SignUser from "@/components/sign/user";
import { useAppContext } from "@/contexts/app";
import { isAuthEnabled } from "@/lib/auth";
import { cn } from "@/lib/utils";
import { useTranslations } from "next-intl";

interface SiteHeaderAuthProps {
  className?: string;
}

export default function SiteHeaderAuth({ className }: SiteHeaderAuthProps) {
  const t = useTranslations();
  const { user, setShowSignModal } = useAppContext();

  if (!isAuthEnabled()) {
    return null;
  }

  if (user) {
    return <SignUser user={user} isAdmin={user.isAdmin} />;
  }

  return (
    <button
      type="button"
      onClick={() => setShowSignModal(true)}
      className={cn(className)}
    >
      {t("user.sign_in")}
    </button>
  );
}
